import * as React from 'react'
import { SVGProps } from 'react'

function CustomRadioButton(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
      <rect width={31} height={31} x={0.5} y={0.5} fill="#fff" rx={15.5} />
      <rect width={31} height={31} x={0.5} y={0.5} stroke="#D4D4D4" rx={15.5} />
    </svg>
  )
}

function CustomRadioButtonChecked(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} fill="none" {...props}>
      <rect width={32} height={32} fill={props.color ?? '#1D59AF'} rx={16} />
      <path stroke="#fff" strokeWidth={2} d="m9 16.5 4 4 9.5-9.5" />
    </svg>
  )
}

export const RadioButton = {
  CustomRadioButton,
  CustomRadioButtonChecked,
}
